import React, { useState, useEffect } from "react";
import { array, bool, func, number, object, string } from "prop-types";
import { LoadMoreCollectionStories } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import { googleTagEvents } from "../../utils/utils";
import Headline from "../../atoms/Headline";

import { useAutoRefresh } from "../../utils/react-utils";

import "./collection.m.css";
import Stories2AdWithLoadMore from "../../rows/Stories2AdWithLoadMore";

const NO_OF_STORIES_TO_LOAD = 10;

const CollectionPageBase = ({ data: { collection }, language }) => {
  const stories = collection.items.filter((item) => item.type === "story");
  const collectionSlug = collection.slug;

  const list = stories.map((story) => story);
  const remainingStoriesSet = list.map(({ story }) => story).slice(0, 16);

  useAutoRefresh(collectionSlug);

  // NTG
  const [scroll, setScroll] = useState(0);
  const scrollEventTrigger = (value) => {
    googleTagEvents("article-milestone", collectionSlug, value);
  };
  useEffect(() => {
    const scrollCalculate = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.body.offsetHeight;
      const winHeight = window.innerHeight;
      const scrollPercent = scrollTop / (docHeight - winHeight);
      const scrollPercentRounded = Math.round(scrollPercent * 100);
      if (scrollPercentRounded >= 25 && scrollPercentRounded < 50) {
        if (scroll < 25) {
          setScroll(25);
          scrollEventTrigger(25);
        }
      } else if (scrollPercentRounded >= 50 && scrollPercentRounded < 75) {
        if (scroll < 50) {
          setScroll(50);
          scrollEventTrigger(50);
        }
      } else if (scrollPercentRounded >= 75 && scrollPercentRounded < 90) {
        if (scroll < 75) {
          setScroll(75);
          scrollEventTrigger(75);
        }
      } else if (scrollPercentRounded >= 90) {
        if (scroll < 90) {
          setScroll(90);
          scrollEventTrigger(100);
        }
      }
    };
    if (window) {
      window.addEventListener("scroll", scrollCalculate);
      return () => {
        window.removeEventListener("scroll", scrollCalculate);
      };
    }
  }, [scroll]);

  const defaultCollectionName = () => (
    <div id="section-meta-wrapper" styleName="content">
      <div styleName="collection-name">
        <Headline text={collection.name} headerLevel={1} headlineType={38} className="title" />
      </div>
    </div>
  );

  return (
    <div>
      {defaultCollectionName()}
      {stories.length > 0 ? (
        <LoadMoreCollectionStories
          collectionSlug={collectionSlug}
          template={MoreCollectionStories}
          data={{ stories: remainingStoriesSet }}
          numStoriesToLoad={NO_OF_STORIES_TO_LOAD}
        />
      ) : (
        <div styleName={`no-stories ${language}-no-stories`}>No stories found !!</div>
      )}
    </div>
  );
};

const MoreCollectionStories = ({ stories, onLoadMore, loading, noMoreStories, language }) => (
  <Stories2AdWithLoadMore
    list={stories}
    loading={loading}
    onLoadMore={onLoadMore}
    isMoreStories={NO_OF_STORIES_TO_LOAD <= stories.length && !noMoreStories}
    className="loadmore-stories"
    sideAd={language === "en" ? "EnPalo_ROS_300x250_R1" : "News_336x280_R1"}
    midAd={language === "en" ? "EnPalo_ROS_300x250_R2" : "News_336x280_R2"}
    moreAd={language === "en" ? "EnPalo_ROS_336x280_R3" : "News_336x280_R3"}
  />
);

CollectionPageBase.propTypes = {
  data: object,
  language: string,
};

MoreCollectionStories.propTypes = {
  stories: array.isRequired,
  onLoadMore: func,
  noMoreStories: number,
  loading: bool,
  language: string,
};

const mapStateToProps = (state) => ({
  language: get(state, ["qt", "config", "publisher-attributes", "lang"], "en"),
});

export const CollectionPage = connect(mapStateToProps, null)(CollectionPageBase);
